import * as go from "gojs";

import elements from "../Diagram/newElements.json";
import boiler from "../Diagram/elementsData/boiler.json";
import comments from "../Diagram/elementsData/comments.json";
import container from "../Diagram/elementsData/container.json";
import equipment from "../Diagram/elementsData/equipment.json";
import heatExchanger from "../Diagram/elementsData/heatExchanger.json";
import others from "../Diagram/elementsData/others.json";
import products from "../Diagram/elementsData/products.json";
import pump from "../Diagram/elementsData/pump.json";
import reactor from "../Diagram/elementsData/reactor.json";
import separator from "../Diagram/elementsData/separator.json";
import tank from "../Diagram/elementsData/tank.json";
import tower from "../Diagram/elementsData/tower.json";
import Flash2 from "../Diagram/elementsData/Flash2.json";
import MultiStreamExchanger from "../Diagram/elementsData/MultiStreamExchanger.json";
import Mixer from "../Diagram/elementsData/Mixer.json";
import Group from "../Diagram/elementsData/group.json";
import Link from "../Diagram/elementsData/link.json";


export function loadOverview(diagram, objDIV) {
  const $ = go.GraphObject.make;
  const overview = $(go.Overview, objDIV, {
    observed: diagram,
    contentAlignment: go.Spot.Center,
  });
  return overview;
}


export function buildSelectedElementData(element) 
{
    let elementType = "";
    let elementID = element.key;
    let elementName = "";
    let elementNodeType = null;
    let elementSecondaryTypeName = null;
    let elementGroupKey = null;
    let basicData = {};
    let paramsData = {};
    let materialsData = {};

    let elementData = 
    {
        elementType:elementType,
        elementID:elementID,
        elementName:elementName,
        elementNodeType:elementNodeType,
        elementSecondaryTypeName:elementSecondaryTypeName,
        elementGroupKey:elementGroupKey,
        basicData:basicData,
        paramsData:paramsData,
        materialsData:materialsData,
    };

    //判断选中项类型
    if(element.nodeName)
    {
        elementType = "node";
        elementName = element.nodeName;
        elementNodeType = element.type;
        elementSecondaryTypeName = element.elementName;
        elementGroupKey = element.group ? String(element.group) : "无";
    }
    else if(element.linkName)
    {
        elementType = "link";
        elementName = element.linkName;
        elementGroupKey = element.group[0] ? String(element.group[0]) : "无";
    }
    else if(element.isGroup)
    {
        elementType = "group";
        elementName = element.groupName;
    }
    else
    {
        return elementData;
    }

    if(elementType==="node")
    {
        //元件基础参数
        basicData = 
        {
            "元件名称":{value:element.nodeName,engName:"nodeName",show:true},
            "物性计算方法":{value:element.physical_method,engName:"physical_method",show:true,enum:[{label:"NRTL",value:"NRTL"},{label:"SRK",value:"SRK"}]},
            "相态":{value: element.phase,engName:"phase",show:true,enum:[{label:"L-液相",value:"L"},{label:"V-汽相",value:"V"},{label:"VL-汽液两相",value:"VL"}]},
            "计算模式":{value:element.mode,engName:"mode",show:true,enum:[{label:"TP-温压闪蒸",value:"TP"},{label:"VP-汽化率压力闪蒸",value:"VP"},{label:"HP-压焓闪蒸",value:"HP"}]},
            "描述":{value:element.description,engName:"description",show:false}
        };

        //元件参数
        paramsData = element.ParamValues;
    }
    else if(elementType==="link")
    {
        //流股基础参数
        basicData = 
        {
            "流股名称":{value:element.linkName,engName:"linkName",show:true},
            "描述":{value:element.description,engName:"description",show:false}
        };

        //流股参数
        paramsData = element.ParamValues;

        //流股组分参数
        materialsData = element.materials;
    }
    else if(elementType==="group")
    {
        //分组基础参数
        basicData = 
        {
            "分组名称":{value:element.groupName,engName:"groupName",show:true},
            "描述":{value:element.description,engName:"description",show:false}
        };

        //分组参数
        paramsData = element.ParamValues;
    }

    elementData = 
    {
        elementType:elementType,
        elementID:elementID,
        elementName:elementName,
        elementNodeType:elementNodeType,
        elementSecondaryTypeName:elementSecondaryTypeName,
        elementGroupKey:elementGroupKey,
        basicData:basicData,
        paramsData:paramsData,
        materialsData:materialsData,
    };
    return elementData;
}

//构建元件类型参数索引表
export const buildNodeTypeParamsForm = () => 
{
    let nodeTypeParamsForm = {};
    
    const typeIdExtraElementsParams = 
    {
      boiler:boiler,
      comments:comments,
      container:container,
      equipment:equipment,
      ShellAndTubeExchanger:heatExchanger,
      others:others,
      products:products,
      pump:pump,
      reactor:reactor,
      Splitter:separator,
      tank:tank,
      DistilStrict:tower,
      Flash2:Flash2,
      Mixer:Mixer,
      MultiStreamExchanger:MultiStreamExchanger,
      group:Group,
      link:Link
    };

    for(let i=0;i<elements.length;i++)
    {
        let element = elements[i];
        let typeId = element.typeID;
        let publicParams = element.params;

        let newParams = {};
        for(let j=0;j<publicParams.length;j++)
        {
            let publicParam = publicParams[j];
            let p_engName = publicParam.p_engName;
            newParams[p_engName] = publicParam;
        }

        let extraElementDatas = typeIdExtraElementsParams[typeId];
        if(extraElementDatas)
        {
            for(let j=0;j<extraElementDatas.length;j++)
            {
                let extraElementData = extraElementDatas[j];
                let elementName = extraElementData.nodeName;
                let extraParams = extraElementData.params;

                let newExtraParams = {};
                for(let k=0;k<extraParams.length;k++)
                {
                    let extraParam = extraParams[k];
                    let p_engName = extraParam.p_engName;
                    newExtraParams[p_engName] = extraParam;
                }

                let allParams = {...newParams,...newExtraParams};

                nodeTypeParamsForm[elementName] = allParams;
            }
        }
    }

    return nodeTypeParamsForm;
};

//查询指定元件的关联元件(元件查询流股,流股查询元件)
export const queryRelateElement = (selectedElementData,dataSource) => 
{
    let fromNodes = [];
    let toNodes = [];
    let allNodes = [];
    let inLinks = [];
    let outLinks = [];
    let allLinks = [];

    if(selectedElementData.elementType==="node")
    {
        //查询关联流股
        let selectedElementKey = selectedElementData.elementID;
        let linkDatas = dataSource.linkDataArray;

        for(let i=0;i<linkDatas.length;i++)
        {
            let linkData = linkDatas[i];

            let link = 
            {
                key:linkData.key,
                name:linkData.linkName,
                data:linkData
            };

            if(linkData.to===selectedElementKey)
            {
                inLinks.push(link);
            }
            if(linkData.from===selectedElementKey)
            {
                outLinks.push(link);
            }
            if(linkData.to===selectedElementKey || linkData.from===selectedElementKey)
            {
                allLinks.push(link);
            }
        }
    }
    else if(selectedElementData.elementType==="link")
    {
        //查询关联元件
        let selectedElementKey = selectedElementData.elementID;
        let selectedLinkData = dataSource.linkDataArray.find(item=>item.key===selectedElementKey);
        let nodeDatas = dataSource.nodeDataArray.filter(item=>item.type!=="comments");

        if(selectedLinkData)
        {
            for(let i=0;i<nodeDatas.length;i++)
            {
                let nodeData = nodeDatas[i];

                let node = 
                {
                    key:nodeData.key,
                    name:nodeData.nodeName,
                    data:nodeData
                };
                if(selectedLinkData.from===nodeData.key)
                {
                    fromNodes.push(node);
                }
                if(selectedLinkData.to===nodeData.key)
                {
                    toNodes.push(node);
                }
                if(selectedLinkData.from===nodeData.key || selectedLinkData.to===nodeData.key)
                {
                    allNodes.push(node);
                }
            }
        }
    }
    else if(selectedElementData.elementType==="group")
    {

    }

    let relateElements = 
    {
        fromNodes:fromNodes,
        toNodes:toNodes,
        allNodes:allNodes,
        inLinks:inLinks,
        outLinks:outLinks,
        allLinks:allLinks,
    };

    return relateElements;
};
